"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorFallback = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const View_1 = require("@amzn/atoz-web/View");
const Text_1 = require("@amzn/atoz-web/Text");
const Theme_1 = require("@amzn/atoz-web/Theme");
const ErrorPerson_web_1 = require("../ErrorPerson/ErrorPerson.web");
const ErrorFallback = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return (react_1.default.createElement(ErrorFallbackContainer, { dataTestId: "ErrorFallback", className: "taa-error-fallback" },
        react_1.default.createElement(ErrorPerson_web_1.ErrorPerson, { className: "error-image", alt: 'error' }),
        react_1.default.createElement(Text_1.Text, null, t('time_and_attendance_Shared_ErrorFallback_ErrorText'))));
};
exports.ErrorFallback = ErrorFallback;
const ErrorFallbackContainer = (0, Theme_1.styledWithTheme)(View_1.View)(`
    display: flex;
    margin: 20px 0;
    align-items: center;
    .error-message {
      margin: 0;
    }
  `);
